import { useDeviceType } from '@cian/ui-kit';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { NewPresentationBlock } from 'shared/components/NewPresentationBlock';
import { PresentationBlock } from 'shared/components/PresentationBlock';
import { RootMortgageWrapper } from 'shared/constants/common';
import { ERuntimeSettings } from 'shared/types/runtimeSettings';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { scrollToOffersListing } from 'shared/utils/scroll';
import { selectH1Tag, selectSeoBreadcrumbItems } from '../../selectors/landing';
import { useTracking } from '../../utils/tracking/useTracking';

export const PresentationBlockContainer = () => {
  const { trackClickOnTargetButton } = useTracking();
  const { config } = useApplicationContext();
  const deviceType = useDeviceType();
  const title = useSelector(selectH1Tag);
  const breadcrumbs = useSelector(selectSeoBreadcrumbItems);
  const mortgageLandingRedesignEnabled = config.get<boolean>(ERuntimeSettings.mortgageLandingRedesign);

  const onScrollToMortgageBlock = useCallback(() => {
    trackClickOnTargetButton();

    if (mortgageLandingRedesignEnabled) {
      scrollToOffersListing({ isDesktop: deviceType === 'desktop' });

      return;
    }

    document.getElementById(RootMortgageWrapper)?.scrollIntoView({
      behavior: 'smooth',
    });
  }, [deviceType, mortgageLandingRedesignEnabled, trackClickOnTargetButton]);

  if (mortgageLandingRedesignEnabled) {
    // TODO: убрать New из названия после ФТ
    return <NewPresentationBlock breadcrumbs={breadcrumbs} onCtaClick={onScrollToMortgageBlock} />;
  }

  return (
    <PresentationBlock
      breadcrumbs={breadcrumbs}
      title={title}
      description="Льготные программы, эксклюзивные предложения — всё здесь"
      handleClickButton={onScrollToMortgageBlock}
    />
  );
};
